
// Init livewire?
document.addEventListener('DOMContentLoaded', () => {

    // Depend on Livewire bundled with Alpine?
    if(window.Livewire) {

        // Not needed since Livewire 3, see https://livewire.laravel.com/docs/installation#manually-bundling-livewire-and-alpine
        //window.Alpine.start();

        window.Livewire.start();
    }
    
});
